import React from 'react';
import proptypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';

const { number } = proptypes;

export const EntireProject = ({ itemCount, groupCount }) => {
  return (
    <div>
      <Typography>
        Entire Project{' '}
        <Typography color="subtle" component="span">
          ({itemCount} items | {groupCount} groups)
        </Typography>
      </Typography>
    </div>
  );
};

EntireProject.propTypes = {
  itemCount: number.isRequired,
  groupCount: number.isRequired
};

EntireProject.defaultProps = {};
